import { MouseEvent, useCallback, useState } from "react";

import {
	GridCellModes,
	GridCellModesModel,
	GridCellParams,
} from "@mui/x-data-grid";

export const useDataGridSingleClickEditing = () => {
	const [cellModesModel, setCellModesModel] = useState<GridCellModesModel>({});

	const handleCellClick = useCallback(
		(params: GridCellParams, event: MouseEvent) => {
			if (!params.isEditable) {
				return;
			}

			// Ignore portal
			if (!event.currentTarget.contains(event.target as Element)) {
				return;
			}

			setCellModesModel((prevModel) => {
				return {
					// Revert the mode of the other cells from other rows
					...Object.keys(prevModel).reduce(
						(acc, id) => ({
							...acc,
							[id]: Object.keys(prevModel[id]).reduce(
								(acc2, field) => ({
									...acc2,
									[field]: { mode: GridCellModes.View },
								}),
								{},
							),
						}),
						{},
					),
					[params.id]: {
						// Revert the mode of other cells in the same row
						...Object.keys(prevModel[params.id] || {}).reduce(
							(acc, field) => ({
								...acc,
								[field]: { mode: GridCellModes.View },
							}),
							{},
						),
						[params.field]: { mode: GridCellModes.Edit },
					},
				};
			});
		},
		[],
	);

	const handleCellModesModelChange = useCallback(
		(newModel: GridCellModesModel) => {
			setCellModesModel(newModel);
		},
		[],
	);

	return { cellModesModel, handleCellModesModelChange, handleCellClick };
};
